<template>
  <div>
    <div class="content">
      <div class="lald-case__block-head-child d-md-none mb-8">
        <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
        <div class="lald-case__block-head-child-avatar">
          <img
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
          />
        </div>
      </div>
      <div class="lald-case__block">
        <div class="lald-case__block-head">
          <div class="lald-case__block-head-title">
            Результаты УЗИ органов брюшной полости
          </div>
          <div class="lald-case__block-head-child d-none d-md-flex">
            <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
            <div class="lald-case__block-head-child-avatar">
              <img
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
              />
            </div>
          </div>
        </div>
        <div class="lald-case__block-body">
          <p class="default-text">
            Выявлены эхо-признаки гепатомегалии с диффузными изменениями
            паренхимы печени (+2 см из-под края реберной дуги). Обнаружены
            диффузные изменения поджелудочной железы. Селезенка не увеличена,
            структура однородная средней эхогенности.
          </p>
          <div
            class="lald-case__button button button_orange-gradient mt-4"
            :class="{ button_disabled: visitedSteps.includes(2) }"
            @click="$emit('toStep', 2)"
          >
            <svg
              width="15"
              height="20"
              viewBox="0 0 15 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 0C7.5 0 0 6.89656 0 12.4138C0 16.6035 3.35789 20 7.5 20C11.6421 20 15 16.6035 15 12.4138C15 6.89656 7.5 0 7.5 0ZM10.625 13.6782H8.75001V15.5747H6.24999V13.6782H4.37498V11.1494H6.24999V9.25285H8.75001V11.1494H10.625V13.6782Z"
                fill="white"
              />
            </svg>
            Назначить биохимический анализ
          </div>
        </div>
      </div>
      <div class="lald-case__tools">
        <div class="lald-case__back" @click="$emit('back')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.25 19.5L3.75 12L11.25 4.5"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
            <path
              d="M5.25 12L20.25 12"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
          Назад
        </div>
        <div class="lald-case__buttons">
          <div
            class="lald-case__button button button_violet-solid"
            @click="$emit('toStep', 4)"
          >
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.96 4.22479L7.55 6.95434C4.97 7.21525 3 9.3728 3 11.9719C3 13.3026 3.52678 14.5789 4.46447 15.5199C5.40215 16.4608 6.67392 16.9895 8 16.9895C10.05 16.9895 11.81 15.7551 12.58 13.9789H10V11.9719H18V13.9789H15.75C15.3458 15.5326 14.4893 16.93 13.29 17.993H16V20H0V17.993H2.71C1.85847 17.2397 1.17643 16.3133 0.709182 15.2752C0.241936 14.237 0.000187997 13.111 0 11.9719C0 8.32915 2.46 5.14802 5.96 4.22479ZM9.24 0L10 1.30457L10.86 0.80281L14.36 6.88409L10.89 8.89112L7.39 2.80983L8.26 2.30808L7.5 1.00351L9.24 0Z"
                fill="white"
              />
            </svg>

            Отправить на диагностику ДЛКЛ
          </div>
          <div
            class="lald-case__button button button_orange-gradient"
            @click="$emit('toStep', 5)"
          >
            <svg
              width="17"
              height="20"
              viewBox="0 0 17 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5175 13.7946C14.7262 14.4108 17 15.9892 17 17.8378V20H0V17.8378C0 15.9892 2.27375 14.4108 5.4825 13.7946L8.5 18.9189L11.5175 13.7946ZM4.25 6.48648H12.75V8.64864C12.75 9.79552 12.3022 10.8954 11.5052 11.7064C10.7082 12.5174 9.62717 12.9729 8.5 12.9729C7.37283 12.9729 6.29183 12.5174 5.4948 11.7064C4.69777 10.8954 4.25 9.79552 4.25 8.64864V6.48648ZM4.25 5.4054L4.68562 0.972984C4.71205 0.705392 4.83556 0.45743 5.03203 0.277519C5.22849 0.0976079 5.48381 -0.00133415 5.74813 1.35895e-05H11.2625C11.8044 1.35895e-05 12.2612 0.421634 12.3144 0.972984L12.75 5.4054H4.25ZM8.5 1.08109H7.4375V2.16217H6.375V3.24325H7.4375V4.32433H8.5V3.24325H9.5625V2.16217H8.5V1.08109Z"
                fill="white"
              />
            </svg>

            Поставить предварительный диагноз
          </div>
        </div>
      </div>
    </div>
    <div class="lald-case__shorts">
      <div class="content">
        <p class="default-text">ДЛКЛ – дефицит лизосомнойкислой липазы</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step4",
  props: {
    visitedSteps: Array,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/laldICC.scss";

.lald-case {
  &__block {
    &-body {
      &-prop {
        display: grid;
        grid-template-columns: 170px 1fr;
        gap: 60px;
        align-items: center;

        &:not(:last-child) {
          margin-bottom: 16px;
        }

        &-value {
          color: #5c539e !important;
        }
      }
    }
  }
}
</style>